module.exports = __webpack_public_path__ + "img/mountain.33385338.png";